import { Injector, NgModule, Optional } from '@angular/core';
import {  NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AppComponent } from './app.component';

import { SharedModule, TranslationService } from '@whitehatgaming/shared';

import { CreateAccountComponent } from './create-account/create-account.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { brandConfig } from './brand-config';

import { AppInjector } from 'projects/web-components/src/app/core-services/app.injector';
import { environment } from '../environments/environment';
import { SharedComponentModule } from 'projects/web-components/src/app/shared-component.module';
import { CustomFooterComponent } from './custom-footer/custom-footer.component';

@NgModule({
  declarations: [
    AppComponent,
    CreateAccountComponent,
    CustomFooterComponent
  ],
  imports: [
    AppRoutingModule, // first to declare wins
    SharedModule.forRoot(brandConfig, environment, null),
    TranslateModule,
    SharedComponentModule,
  ],
  providers: [NgbActiveModal],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private injector: Injector,
    @Optional() ngSharedTranslationService?: TranslationService,
    @Optional() ngxTranslateService?: TranslateService
  ) {

    /*
    * This is only here for localhost to work when testing Angular elements
    */
    AppInjector.injector = this.injector;

    // Hook the web components translate service into the shared service
    if (ngSharedTranslationService && ngxTranslateService) {
      ngSharedTranslationService.languageObservable.subscribe(language => {
        ngxTranslateService.use(language);
      });
    }
  }
}
